// utils/time.js
export function pad2(n) {
  return String(n).padStart(2, '0');
}

export function minToHm(min) {
  const h = Math.floor(Number(min) / 60);
  const m = Number(min) % 60;
  return `${pad2(h)}:${pad2(m)}`;
}
